import RegisterTokenPage from "./pages/RegisterTokenScreen"
import ForgotPasswordPage from "./pages/ForgotPasswordPage"
import ResetPasswordPage from "./pages/ResetPasswordPage"
import LoginPage from "./pages/LoginPage"
import UserProfile from "./pages/Users/UserProfile"
import UserBookings from "./pages/Users/UserBookings"
import UserInvoices from "./pages/Users/UserInvoices"
import { Routes, Route, Navigate } from "react-router-dom"
import DashboardLayout from "./pages/DashboardLayout"
import AuthLayout from "./pages/AuthLayout"
import ProtectedRoute from "./pages/ProtectedRoute"
import BookingDetailsPage from "./pages/Users/BookingDetailsPage"

const App = () => {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <AuthLayout>
            <LoginPage />
          </AuthLayout>
        }
      />
      <Route
        path="/register/:token"
        element={
          <AuthLayout>
            <RegisterTokenPage />
          </AuthLayout>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <AuthLayout>
            <ForgotPasswordPage />
          </AuthLayout>
        }
      />
      <Route
        path="/reset-password"
        element={
          <AuthLayout>
            <ResetPasswordPage />
          </AuthLayout>
        }
      />

      {/* Route 2: Authenticated Dashboard Routes (Protected) */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        {/* Nested routes render inside DashboardLayout's <Outlet /> */}
        <Route index element={<UserProfile />} /> {/* Default page at "/" */}
        <Route path="bookings" element={<UserBookings />} />
        <Route path="bookings/:bookingId" element={<BookingDetailsPage />} />
        <Route path="invoices" element={<UserInvoices />} />
        {/* Add a fallback for any other nested route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export default App
